import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { LfsaBotonEditarGridComponent} from '../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';
import { event } from 'jquery';
import { MaterialService } from '../../services/material.service';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import { nivelCalidadService } from '../../services/nivelCalidad.service';

@Component({
  selector    : 'app-mantenedor-niveles-dobi',
  templateUrl : './mantenedor-niveles-dobi.component.html',
  styleUrls   : ['./mantenedor-niveles-dobi.component.css'],
})

export class MantenedorNivelesDobiComponent implements OnInit {
  public loading    : boolean = false;
  public isCreate   : boolean = true;
  public materialInvalido  : boolean = false;

  public DAT_TITULOS  : any = moduloGaritas.titulos.mantenerDobi;
  public DAT_BTNS     : any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS   : any = moduloGaritas.button.buttonsCss;
  public DAT_MSG      : any = moduloGaritas.mensajes;
  public titleModal   : string;
  public DAT_AG_GRID  : any = moduloGaritas.agGrid;

  public columnDefs   : any[] = [];
  public rowData      : any[] = [];
  public gridApi      : any;
  public gridColumnApi: any;
  public frameworkComponents: any;

  public mantenerRegistroForm = new FormGroup({
    material    : new FormControl('', [Validators.required, Validators.pattern(/[0-9]+/),  Validators.maxLength(10)]),
    desMaterial : new FormControl('', [Validators.required]),
    dobiInicio  : new FormControl('', [Validators.required]),
    dobiFinal   : new FormControl('', [Validators.required]),
    tpCalidad   : new FormControl('', [Validators.required, Validators.maxLength(1)]),
  });

  constructor(
    private _util           : UtilsService,
    private materialService : MaterialService,
    private nCalidadService : nivelCalidadService,
  ) { }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefs = [,
      {
        field: 'material',
        sortable: true,
        filter: true,
      },
      {
        field: 'dobiInicio',
        sortable: true,
        filter: true,
      },
      {
        field: 'dobiFinal',
        sortable: true,
        filter: true,
      },
      {
        field: 'tpCalidad',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 90,
        cellRendererParams: {
          onClick: this.editarRegistro.bind(this),
          label: 'Editar',
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 90,
        cellRendererParams: {
          onClick: this.eliminarRegistro.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger,
        }
      }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

desHabilita(){
  if(this.isCreate){
      this.mantenerRegistroForm.get('material')?.enable();
      this.mantenerRegistroForm.get('desMaterial')?.enable();
      this.mantenerRegistroForm.get('dobiInicio')?.enable();
  }else{
    this.mantenerRegistroForm.get('material').disable();
    this.mantenerRegistroForm.get('desMaterial').disable();
    this.mantenerRegistroForm.get('dobiInicio').disable();
  }
}

  ngOnInit(): void {
    this.gridComponent();
    this.obtenerTodo();
  }

  obtenerTodo() {
    this.loading = true;
    this.rowData = [];

    this.nCalidadService.obtener().subscribe(
      (resp) =>   { this.rowData = resp;  },
      (error) =>  { this.rowData = [];  console.log(error); }
    );

    this.loading = false;
  }

  nuevoRegistro(){
    this.isCreate   = true;
    this.titleModal = this.DAT_TITULOS.tituloAgregar;
    this.mantenerRegistroForm.reset();
    this.desHabilita();
    this.openModal();
  }

  editarRegistro({rowData}){
    this.isCreate   = false;
    this.titleModal = this.DAT_TITULOS.tituloActualizar;
    this.mantenerRegistroForm.reset();
    this.mantenerRegistroForm.patchValue(rowData);
    this.desHabilita();
    this.openModal();
    this.onChangeMaterial(event);
  }

  eliminarRegistro({ rowData }){
    this.loading = true;
    
    this._util
      .confirmarSincronoPromesa({
        title   : this.DAT_MSG.eliminar,
        text    : `Eliminar rango para material: ${rowData.material + ' - ' + rowData.dobiInicio + ' a ' + rowData.dobiFinal}`,
        action  : this.DAT_BTNS.eliminar,
        funcion : this.nCalidadService.borrar(rowData),
      })
      .then((res: any) => {
        this.obtenerTodo();
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  onChangeMaterial(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;

    if(this.mantenerRegistroForm.get("material").value != undefined && this.mantenerRegistroForm.get("material").value.length >= 9){
      this.materialService.obtenerPorId(this.mantenerRegistroForm.get("material").value).subscribe(
        (resp) => {
          if (resp) {
            this.materialInvalido = false;
            this.mantenerRegistroForm.controls['desMaterial'].setValue(resp.idMaterial + " - " + resp.dscaMaterial);
          } else {
            this.materialInvalido = true;
            this.mantenerRegistroForm.controls['desMaterial'].setValue('');
          }
        },
        (error) => {
          this.loading = false;
          this.materialInvalido = true;
          this.mantenerRegistroForm.controls['desMaterial'].setValue('');
        }
      );
    }

    this.loading = false;

  }

  guardarEditarRegistro() {
    this.loading = true;
    if (this.mantenerRegistroForm.invalid) return;

    let obj         = this.mantenerRegistroForm.getRawValue();  
    obj.dobiInicio  = parseFloat(obj.dobiInicio);
    obj.dobiFinal   = parseFloat(obj.dobiFinal);
    obj.material    = obj.material.trim();

    console.log("datosFormulario a Enviar", obj);

    this._util
      .confirmarSincronoPromesa({
        title   : this.isCreate ? this.DAT_MSG.procesar : this.DAT_MSG.actualizar,
        text    : this.isCreate ? "VALOR PARA MATERIAL " + obj.material : obj.material,
        action  : this.isCreate ? this.DAT_BTNS.nuevo : this.DAT_BTNS.editar,
        funcion : this.isCreate ? this.nCalidadService.crear(obj) : this.nCalidadService.editar(obj),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    this.guardarEditarRegistro();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  getFormValidationErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');
    let totalErrors = 0;

    Object.keys(this.mantenerRegistroForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.mantenerRegistroForm.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  keyDecimals(event: KeyboardEvent) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

}
